// extracted by mini-css-extract-plugin
export default {"versionModal":"VersionCheck_versionModal__h4NAz"};